/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Region } from 'src/core/types/regionTypes';

export class AzureSearchStore {
    public id: string;

    public path: string;

    public name: string;

    public location: Region;

    public sku: AzureSearchServiceSku;

    constructor(id: string, data: Partial<Omit<AzureSearchStore, 'id'>>) {
        this.id = id;
        this.path = data.path;
        this.name = data.name;
        this.location = data.location;
        this.sku = data.sku;
    }
}

export type AzureSearchServiceSku = {
    name: 'basic' | 'free' | 'standard' | 'standard2' | 'standard3' | 'storage_optimized_l1' | 'storage_optimized_l2';
};
